const state = {
    active: 0,
}

const mutations = {
    setActive(state, active) {
        state.active = active;
    }
}

export default {
    namespaced: true,
    state,
    mutations
}